exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-container .roles-table[data-v-15e4ada8]{margin-top:30px}.app-container .permission-tree[data-v-15e4ada8]{margin-bottom:30px}", ""]);

// exports
